import type { ConnectionSummary } from "@papersflow/contracts";

export type WorkspaceConnectionAccess =
  | { readonly status: "loading"; readonly workspaceName?: string }
  | {
      readonly status: "ready";
      readonly workspaceName: string;
      readonly connections: readonly ConnectionSummary[];
    }
  | { readonly status: "forbidden"; readonly workspaceName: string }
  | { readonly status: "no-workspace" };

export function projectWorkspaceConnectionAccess({
  workspaceRowsLoaded,
  workspaceName,
  canUseConnections,
  connectionsLoaded,
  connections,
}: {
  readonly workspaceRowsLoaded: boolean;
  readonly workspaceName: string | undefined;
  readonly canUseConnections: boolean;
  readonly connectionsLoaded: boolean;
  readonly connections: readonly ConnectionSummary[];
}): WorkspaceConnectionAccess {
  if (!workspaceRowsLoaded) return { status: "loading" };
  if (!workspaceName) return { status: "no-workspace" };
  if (!canUseConnections) return { status: "forbidden", workspaceName };
  if (!connectionsLoaded) return { status: "loading", workspaceName };
  return { status: "ready", workspaceName, connections };
}
